import { createSlice } from '@reduxjs/toolkit'

import api, { createWrappedAsyncThunk } from 'src/api'

const SLICE_NAME = 'supplier/products'

// Fetch product
export const fetchProducts = createWrappedAsyncThunk(
  `${SLICE_NAME}/fetchProducts`,
  () => api.get(`/supplier/products/`)
)

export const fetchSingleProduct = createWrappedAsyncThunk(
  `${SLICE_NAME}/fetchSingleProduct`,
  id => api.get(`/supplier/products/${id}/`)
)

export const addProduct = createWrappedAsyncThunk(
  `${SLICE_NAME}/addProduct`,
  params => api.post(`/supplier/products/`, { body: params })
)

export const editProduct = createWrappedAsyncThunk(
  `${SLICE_NAME}/editProduct`,
  ({ id, params }) => api.put(`/supplier/products/${id}/`, { body: params })
)

// Fetch product options
export const fetchAllergenChoices = createWrappedAsyncThunk(
  `${SLICE_NAME}/fetchAllergenChoices`,
  () => api.get('/allergens/')
)

export const fetchCategoryChoices = createWrappedAsyncThunk(
  `${SLICE_NAME}/fetchCategoryChoices`,
  () => api.get('/categories/')
)

export const fetchDietaryChoices = createWrappedAsyncThunk(
  `${SLICE_NAME}/fetchDietaryChoices`,
  () => api.get('/dietary/')
)

export const fetchNutritionalChoices = createWrappedAsyncThunk(
  `${SLICE_NAME}/fetchNutritionalChoices`,
  () => api.get('/nutritional/')
)

export const fetchSustainabilityChoices = createWrappedAsyncThunk(
  `${SLICE_NAME}/fetchSustainabilityChoices`,
  () => api.get('/sustainability/')
)

const initialState = {
  product: null,
  products: [],
  productOptions: {
    allergens: [],
    categories: [],
    dietary: [],
    nutritional: [],
    sustainability: [],
  },
  supplierOptions: {
    sustainability: [],
  },
}

const slice = createSlice({
  name: SLICE_NAME,
  initialState,
  reducers: {},
  extraReducers: {
    [fetchProducts.fulfilled]: (state, { payload }) => {
      state.products = payload
      return state
    },
    [fetchSingleProduct.fulfilled]: (state, { payload }) => {
      state.product = payload
      return state
    },
    [editProduct.fulfilled]: (state, { payload }) => {
      state.product = payload
      return state
    },
    // Product options
    [fetchAllergenChoices.fulfilled]: (state, { payload }) => {
      state.productOptions.allergens = payload
      return state
    },
    [fetchCategoryChoices.fulfilled]: (state, { payload }) => {
      state.productOptions.categories = payload
      return state
    },
    [fetchDietaryChoices.fulfilled]: (state, { payload }) => {
      state.productOptions.dietary = payload
      return state
    },
    [fetchNutritionalChoices.fulfilled]: (state, { payload }) => {
      state.productOptions.nutritional = payload
      return state
    },
    [fetchSustainabilityChoices.fulfilled]: (state, { payload }) => {
      state.productOptions.sustainability = payload.filter(
        o => o.appliesToProduct
      )
      state.supplierOptions.sustainability = payload.filter(
        o => o.appliesToSupplier
      )
      return state
    },
  },
})

export default slice.reducer
